import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { useTranslation } from "react-i18next";
import { AuditModule } from "../../components/Audit/AuditModule";

const Audit = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("audit.title"),
					component: <AuditModule />,
				}}
				right={null}
			/>
		</>
	);
};

export { Audit };
